import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  hasChangedSavedValues,
  hasSelectedFilters,
  NUMBER,
  PRIMITIVES_ARRAY
} from "components/Filters/helper";
import { IConditionBookPageAC } from "store/actions/conditionBookPage";
import { defaultConditionBookFiltersState } from "./helper";

export interface IStateConditionBookFilters {
  selectedRestrictions: string[];
  setSelectedRestrictions: (value: string[]) => void;
  selectedDistances: string[];
  setSelectedDistances: (value: string[]) => void;
  selectedAge: string[];
  setSelectedAge: (value: string[]) => void;
  selectedGender: number;
  setSelectedGender: (value: number) => void;
  selectedConditions: string[];
  setSelectedConditions: (value: string[]) => void;
  hasChangedFiltersValues: boolean;
  hasSavedFiltersValues: boolean;
  hasChangedSavedFiltersValues: boolean;
}

export const useStateConditionBookFilters = (): IStateConditionBookFilters => {
  const { filters: reduxFilters } = useSelector(
    (state: { conditionBookPage: IConditionBookPageAC }) => {
      return state.conditionBookPage;
    }
  );

  const [selectedRestrictions, setSelectedRestrictions] = useState(
    reduxFilters.selectedRestrictions
  );
  const [selectedDistances, setSelectedDistances] = useState(
    reduxFilters.selectedDistances
  );
  const [selectedAge, setSelectedAge] = useState(reduxFilters.selectedAge);
  const [selectedGender, setSelectedGender] = useState(
    reduxFilters.selectedGender
  );
  const [selectedConditions, setSelectedConditions] = useState(
    reduxFilters.selectedConditions
  );

  const localeStateFilters = {
    selectedRestrictions,
    selectedDistances,
    selectedAge,
    selectedGender,
    selectedConditions
  };

  const hasChangedFiltersValues = hasSelectedFilters(
    Object.values(localeStateFilters)
  );
  const hasSavedFiltersValues = Boolean(
    reduxFilters && hasSelectedFilters(Object.values(reduxFilters))
  );

  const hasChangedSavedFiltersValues = [
    hasChangedSavedValues(
      selectedRestrictions,
      reduxFilters?.selectedRestrictions,
      PRIMITIVES_ARRAY
    ),
    hasChangedSavedValues(
      selectedDistances,
      reduxFilters?.selectedDistances,
      PRIMITIVES_ARRAY
    ),
    hasChangedSavedValues(
      selectedAge,
      reduxFilters?.selectedAge,
      PRIMITIVES_ARRAY
    ),
    hasChangedSavedValues(selectedGender, reduxFilters?.selectedGender, NUMBER),
    hasChangedSavedValues(
      selectedConditions,
      reduxFilters?.selectedConditions,
      PRIMITIVES_ARRAY
    )
  ].some(item => item);

  useEffect(() => {
    setSelectedRestrictions(
      reduxFilters?.selectedRestrictions ||
        defaultConditionBookFiltersState.selectedRestrictions
    );
    setSelectedDistances(
      reduxFilters?.selectedDistances ||
        defaultConditionBookFiltersState.selectedDistances
    );
    setSelectedAge(
      reduxFilters?.selectedAge || defaultConditionBookFiltersState.selectedAge
    );
    setSelectedGender(
      reduxFilters?.selectedGender ||
        defaultConditionBookFiltersState.selectedGender
    );
    setSelectedConditions(
      reduxFilters?.selectedConditions ||
        defaultConditionBookFiltersState.selectedConditions
    );
  }, [reduxFilters]);

  return {
    selectedRestrictions,
    setSelectedRestrictions,
    selectedDistances,
    setSelectedDistances,
    selectedAge,
    setSelectedAge,
    selectedGender,
    setSelectedGender,
    selectedConditions,
    setSelectedConditions,
    hasChangedFiltersValues,
    hasSavedFiltersValues,
    hasChangedSavedFiltersValues
  };
};
